<template>
  <div class="tag-list">
    <ul>
      <li
        v-for="(item, key) in tags"
        :key="key"
        class="tag"
      >
        <span class="title">{{ item }}</span>
        <button
          class="delete-btn"
          @click="removeTag(key)"
        >
          x
        </button>
      </li>
      <li class="tag-search-box">
        <textarea
          v-model="tag"
          type="text"
          :placeholder="translate('tag.add')"
          class="form-control border-input"
          @keyup="characterInput"
          @keydown.enter.prevent
        />
      </li>
      <li class="tag-hint">
        {{ translate('tag.hint') }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'TagList',
  model: {
    prop: 'taglist',
    event: 'input'
  },
  props: {
    taglist: {
      type: Array
    }
  },
  data () {
    return {
      tags: [...this.taglist],
      tag: '',
      len_tag: 0
    }
  },
  watch: {
    taglist () {
      this.tags = [...this.taglist]
    }
  },
  methods: {
    characterInput (keyValue) {
      let savedInput = ''
      switch (keyValue.key) {
        case 'Enter': savedInput = this.tag.trim(); break
        case ' ':
        case ',':
        case ';':
          savedInput = this.tag.substring(0, this.tag.length - 1).trim()
          break
        case 'Backspace':
          if (this.tag.length === 0 && this.len_tag === 0) {
            this.tags.pop()
            this.$emit('input', [...this.tags])
          }
          break
        default: // do nothing
      }

      this.len_tag = this.tag.length
      if (savedInput !== '') {
        let list_inputs = savedInput.split(/\n/)
        for (let input of list_inputs) {
          if (this.tags.indexOf(input) === -1 && input !== '') {
            this.tags.push(input.trim())
            this.tag = ''
            this.$emit('input', [...this.tags])
          } else {
            this.tag = ''
          }
        }
      }
    },
    removeTag (id) {
      this.tags.splice(id, 1)
      this.$emit('input', [...this.tags])
    }
  }

}

</script>
<style lang="scss">
.tag-list {
  border: 1px solid #DCDCDC;
  margin: 10px;
  padding: 10px;
}
  .tag-list ul > * {
    display: inline-block;
  }
.tag {
  margin: 2px 3px;
  padding: 2px 4px 3px 6px;
  border-radius: 5px;
  font-size: 1.35rem;
  line-height: 1.75rem;
  background-color: #41B883;
  color: #fff;
}
.tag-search-box {
    margin: 0 !important;
    .form-control{
      height: 42px;
    }
}
.tag-hint {
    font-size: 1rem;
    line-height: 1.25rem;
    color: #b0adab;
    margin: 1rem 0 0;
    display: block !important;
}
  .tag .delete-btn {
       width: 14px;
       height: 14px;
       padding: 1px 0 0 1px;
       margin: 0;
       color: #ffffffa1;
       border: 1px solid #ffffffa1;
       border-radius: 25%;
       background: none;
       font-size: 8px;
       line-height: 12px;
  }
</style>
